export interface ApiErrorResult {
  error: boolean;
  message: string;
}

// ---------------------------------------------------------------------------------------------
export function isApiError(obj: ApiErrorResult | any): obj is ApiErrorResult {
  return (obj as ApiErrorResult).message !== undefined;
}
